// Used to store the Help Widget data

import { uuid } from 'vue-uuid'

const initialChatMessages = [
  {
    text: 'Initialise',
    messageType: 0
  }
]

export const state = () => ({
  id: undefined, // used to track the chat on DB

  open: false,

  chatMessages: [...initialChatMessages],

  page: undefined,

  numberOfchatMessages: 0,

  showSupportMessage: false,

  showOpenTicketForm: false,

  showTicketSentWindow: false
})

export const mutations = {
  id: (state, value) => {
    state.id = value
    return state
  },

  createIdandSavePage: (state, value) => {
    state.id = uuid.v4()
    state.page = value
    return state
  },

  open: (state, value) => {
    state.open = value
    return state
  },

  chatMessages(state, payload) {
    if (payload !== undefined) {
      state.chatMessages = [...payload]
      state.numberOfchatMessages = state?.chatMessages?.filter(el => el.messageType === 0)?.length - 1 || 0
    }
  },

  addMessage(state, message) {
    state.chatMessages = [...state.chatMessages, message]
    state.numberOfchatMessages = state?.chatMessages?.filter(el => el.messageType === 0)?.length - 1 || 0
  },

  resetChatMessages(state, payload) {
    state.chatMessages = [...initialChatMessages]
    state.numberOfchatMessages = state?.chatMessages?.filter(el => el.messageType === 0)?.length - 1 || 0
  },

  showSupportMessage: (state, value) => {
    state.showSupportMessage = value
    return state
  },

  showOpenTicketForm: (state, value) => {
    state.showOpenTicketForm = value
    return state
  },

  showTicketSentWindow: (state, value) => {
    state.showTicketSentWindow = value
    return state
  }
}

export const getters = {
  id: state => {
    return state.id
  },

  open: state => {
    return state.open
  },

  page: state => {
    return state.page
  },

  chatMessages: state => {
    return state?.chatMessages?.filter(el => el.isError === undefined)
  },

  lastMessage: state => {
    return state?.chatMessages?.filter(el => el.messageType === 1).slice(-1)[0] || undefined
  },

  numberOfchatMessages: state => {
    return state.numberOfchatMessages
  },

  showSupportMessage: state => {
    return state.showSupportMessage
  },

  showOpenTicketForm: state => {
    return state.showOpenTicketForm
  },

  showTicketSentWindow: state => {
    return state.showTicketSentWindow
  }
}

export const namespaced = true
